import type { RUICButtonVariants, SBButtonVariants } from "../Button";

export const buttonVaringsConfig: Partial<Record<SBButtonVariants, RUICButtonVariants>> = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "primaryAlt",
};

export const INFO_CHECKMARKS = ["all_airlines", "all_countries", "no_win_no_fee"];
